import { createContext, useContext, useState, type ReactNode } from "react";

export type UserProfile = {
  displayName: string;
  jobTitle: string;
  email: string;
  phone: string;
  photoUrl?: string;
};

const UserProfileContext = createContext<{
  profile: UserProfile;
  updateProfile: (updates: Partial<UserProfile>) => void;
} | null>(null);

export function UserProfileProvider({ children }: { children: ReactNode }) {
  const [profile, setProfile] = useState<UserProfile>({
    displayName: "Responsable RH",
    jobTitle: "Administration RH",
    email: "",
    phone: "",
  });
  return <UserProfileContext.Provider value={{ profile, updateProfile: (updates) => setProfile((current) => ({ ...current, ...updates })) }}>{children}</UserProfileContext.Provider>;
}

export function useUserProfile() {
  const context = useContext(UserProfileContext);
  if (!context) throw new Error("UserProfileProvider manquant");
  return context;
}
